import {
  ToInnerHtml
} from './to-inner-html'

import {
  ToReact
} from './to-react'

export {
  ToInnerHtml,
  ToReact
}



/** WEBPACK FOOTER **
 ** ./lib/render/index.js
 **/